import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ShowBlogs from "../admin/Components/ShowBlogs";
const API_HOST = process.env.REACT_APP_API_URL;

function BlogHeadBlogs() {

  const navigate = useNavigate();
  const [adminName, setAdminName] = useState("");

  async function getCurrentUserName() {
    const authToken = sessionStorage.getItem("authToken");
    if (!authToken) {
      console.error("No auth token found in sessionStorage.");
      return null;
    }
    try {
      const response = await fetch(`${API_HOST}auth/getuser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": authToken,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const userData = await response.json();
      return userData.name;
    } catch (error) {
      console.error("Failed to fetch user:", error);
      return null;
    }
  }

  const checkAndFetchUser = async () => {
      const name = await getCurrentUserName();
      if (name) {
        setAdminName(name);
      }
    }

  useEffect(() => {
    // If authToken exists in session storage, redirect to the admin dashboard
    if (!sessionStorage.getItem("authToken")) {
      navigate("/blogHead/login");
    }
    if (sessionStorage.getItem("authToken")) {

      const userType = sessionStorage.getItem("userType");
      if (userType === "blogger") {
        navigate("/blogger");
      } else if (userType === "blogHead") {
        return;
      }
    }
    
    checkAndFetchUser();
  }, [navigate]);

  useEffect(() => {
    checkAndFetchUser();
  }, []);


  return (
    <>
      <div className="admin-dashboard-container container">
        <div className="dashboard-header">
        
        <div> <h1>Welcome, {adminName}</h1>

          {adminName.startsWith("Pratika") && (
            <p>Access for BDS region 11, dev 11, dev 7, dev 14, dev 15, dev 16</p>
          )}
          </div>
          <div className="flex justify-content-between" style={{

            padding: "8px",
            display: "flex",
            gap: "10px",
          }}>

            <button
              className="logout-button"
              onClick={() => navigate("/blogHead/blogs/create")}
            >
              <b>  Create Blog</b>
            </button>

            <button
              className="logout-button"
              onClick={() => navigate("/blogHead/create-blogger")}
            >
              Create Blogger
            </button>

            <button
              className="logout-button"
              onClick={() => {
                navigate("/blogHead/users");
              }}
            >
              Users
            </button>
            <button
              onClick={() => {
                sessionStorage.removeItem("authToken");
                navigate("/blogHead/login");
              }}
              className="logout-button"
            >
              Logout
            </button>
          </div>
        </div>
        <ShowBlogs />
      </div>
    </>
  );
}

export default BlogHeadBlogs;